module.exports = __webpack_public_path__ + "static/media/play_arrow-white-24px.283a6778.svg";